import React from "react";

function Additional({ stateObj, setStateObj, UpdateProfile, setCurrentDiv }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Product / Service:
            <small style={{ float: "right" }}>
              {stateObj.servicesoffered?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Enter a Product / Services offered with comma separated."
            }
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, servicesoffered: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.servicesoffered}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Industries Served:
            <small style={{ float: "right" }}>
              {stateObj.industriesserved?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            style={{ minHeight: 100 }}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Enter a Industries served with comma separated."
            }
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, industriesserved: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.industriesserved}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">
            Service Areas:
            <small style={{ float: "right" }}>
              {stateObj.servicearea?.length || 0} / 2000
            </small>
          </label>
          <textarea
            type="text"
            id="serviceAreas"
            name="serviceAreas"
            style={{ minHeight: 100 }}
            placeholder="e.g., North America, Europe"
            onChange={(e) => {
              if (e.target.value.length <= 2000)
                setStateObj({ ...stateObj, servicearea: e.target.value });
            }}
            value={stateObj.servicearea}
            className="form-control"
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Types of Marketing Service needed / provided:
            <small style={{ float: "right" }}>
              {stateObj.process?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            style={{ minHeight: 100 }}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "E.g., Traditional Marketing, Digital Marketing, Event Marketing, B2B Marketing..."
            }
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, process: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.process}
          ></textarea>
        </div>
      </div>
      {/* <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            Core Values / Philosophy:
            <small style={{ float: "right" }}>
              {stateObj.philosophy?.length || 0} / 250
            </small>
          </label>
          <textarea
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Core Values  / Philosophy"
            }
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, philosophy: e.target.value });
            }}
            value={stateObj.philosophy}
          ></textarea>
        </div>
      </div> */}
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Collaboration:
            <small style={{ float: "right" }}>
              {stateObj.collabration?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            style={{ minHeight: 100 }}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe To Enter" : ""
            }
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, collabration: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.collabration}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Target Timeline:
            <small style={{ float: "right" }}>
              {stateObj.timemanagement?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            style={{ minHeight: 100 }}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe To Enter" : ""
            }
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, timemanagement: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.timemanagement}
          ></textarea>
        </div>
      </div>
      {/* <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="w-100" htmlFor="linkedin">
            About Yourself:
            <small style={{ float: "right" }}>
              {stateObj.description?.length || 0} / 2000
            </small>
          </label>
          <textarea
            id="aboutyourself"
            name="aboutyourself"
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (e.target.value.length <= 2000)
                setStateObj({ ...stateObj, description: e.target.value });
            }}
            value={stateObj.description}
          ></textarea>
        </div>
      </div> */}

      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Additional;
